import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import { Button } from "@/components/ui/button";

export function ScholarGate({ feature = "This feature" }) {
  return (
    <div className="border border-dashed border-primary bg-primary/5 p-12 text-center max-w-lg mx-auto mt-10" data-testid="scholar-gate">
      <div className="h-12 w-12 bg-primary text-primary-foreground flex items-center justify-center mx-auto mb-5">
        <Crown className="h-6 w-6" />
      </div>
      <h2 className="font-display text-2xl font-bold tracking-tight mb-2">{feature} is a Scholar perk</h2>
      <p className="text-muted-foreground mb-6">Upgrade to Scholar ($19/mo) to unlock Personalpedia, your Personal FAQ, unlimited courses and more.</p>
      <Link to="/pricing"><Button className="rounded-none h-11 px-8 bg-primary hover:opacity-90" data-testid="gate-upgrade-button">Become a Scholar</Button></Link>
    </div>
  );
}

export function isMemberUser(user) {
  return !!user && (user.plan_type === "scholar" || user.plan_type === "enterprise" || user.role === "admin");
}
